import { useQuery } from "@tanstack/react-query";
import { Checkbox, Form, Input, Select, Spin } from "antd";
import { FC } from "react";

import { useDispatch, useSelector } from "react-redux";

import { bookingMembership } from "../../../types/membership";
import { getMemberships } from "../../../network/memberships";
import { setMemberships } from "../../../services/store/slices/cart";
import { useParams } from "react-router-dom";
import { salonLocationBySlug } from "../../../network/clientSide";

interface ServicesProps {}

const Memberships: FC<ServicesProps> = ({}) => {
  //! most logic changed so follow the appointment logic (apis and etc)
  const params = useParams();
  const { salonSlug } = params;
  const { data: salonDetails, isLoading } = useQuery(
    ["salonDetails-memberships", salonSlug],
    () =>
      salonLocationBySlug(salonSlug, {
        link_type: "member_link",
      }),
    {
      enabled: !!salonSlug,
      select: (res) => res?.data?.data?.location,
    }
  );
  console.log(salonDetails);
  const dispatch = useDispatch();
  const { memberships, date, currentLang } = useSelector(
    (state: {
      cart: {
        memberships: {
          memberships: bookingMembership[];
          date: Date | null;
        };
      };
      user: { currentLang: "en" | "ar" };
    }) => {
      return {
        memberships: state.cart.memberships.memberships,
        date: state.cart.memberships.date,
        currentLang: state.user.currentLang,
      };
    }
  );
  if (isLoading) {
    return (
      <div className=" flex absolute justify-center items-center">
        <Spin size="large" />
      </div>
    );
  }
  return (
    <div className="shadow p-6 space-y-4 rounded-lg max-h-[100vh]">
      <div className="space-y-4">
        <h4 className="text-color-primary text-xl ">اختر العضوية</h4>
        <p className="text-color-sec-title">
          قم باختيار العضويات التي تريد شراءها
        </p>
      </div>
      <div>
        <p>العضويات المتاحة</p>
      </div>
      <div className="checkbox-full-width">
        {salonDetails?.link_Memberships?.map((membership: any) => (
          <div
            key={membership?.id}
            className="flex gap-2 items-center max-h-[60vh] overflow-scroll"
          >
            <Checkbox
              checked={
                !!memberships?.find((item) => item?.id === membership?.id)
              }
              onChange={(e) => {
                if (e.target.checked) {
                  dispatch(
                    setMemberships([
                      ...memberships,
                      {
                        id: membership?.id,
                        name: membership?.name,
                        price: +membership?.price,
                        expire_duration: membership?.expire_duration,
                        number_sessions: membership?.number_sessions,
                        services: membership?.pricing_option || [],
                      },
                    ])
                  );
                } else {
                  const filteredMemberships = memberships.filter(
                    (item) => item.id !== membership?.id
                  );
                  dispatch(setMemberships(filteredMemberships));
                }
              }}
              className="w-full bg-[#FBFBFF] "
            >
              <div className="rounded   my-1  bg-white p-1">
                <div className="w-full   flex justify-between p-1 gap-2 items-center   rounded   my-1  ">
                  <p className="text-color-primary font-semibold ">
                    {membership?.name}
                  </p>
                  <p className="text-color-primary">
                    {membership?.price}

                    <span className="mx-1 text-xs text-color-sec-title">
                      ريال سعودي{" "}
                    </span>
                  </p>
                </div>
                <div className="w-full text-xs  flex justify-between p-2 gap-1 items-center   rounded   my-1 ">
                  <p className="  text-color-sec-title">
                    <span className="text-color-primary">
                      {membership?.services?.length}
                    </span>
                    <span className="mx-1">خدمات</span>
                    {`( `}
                    {membership?.pricing_option?.map(
                      (
                        option: {
                          name: string;
                          price: number;
                          duration: string;
                          currency: string;
                          service: {
                            id: number;
                            name: string;
                          };
                        },
                        i: number
                      ) => (
                        <span key={i} className="">
                          {option?.service?.name}{" "}
                          {i !== membership?.pricing_option?.length - 1
                            ? ","
                            : ""}
                        </span>
                      )
                    )}
                    {` )`}
                    <span></span>
                  </p>
                  <p className="">
                    <span className="text-color-primary mx-1">
                      {membership?.number_sessions}{" "}
                      <small className="text-color-sec-title text-xs">
                        جلسات
                      </small>
                    </span>
                    <span className="text-color-primary mx-1">
                      {membership?.days || 30}{" "}
                      <small className="text-color-sec-title text-xs">
                        يوم
                      </small>
                    </span>
                  </p>
                </div>
              </div>
            </Checkbox>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Memberships;
